import { useState, useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import { jaJP } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from './../../contexts/AuthContext';
import { usePost } from './../../apis/ApiRequests';
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid';
import ReaOnlyOutlinedInput from '../../components/input/ReaOnlyOutlinedInput';
import Header from '../../components/Header';
import Frame from '../../components/uiParts/Frame';
import TitleBar from '../../components/uiParts/TitleBar';
import NumPad from '../../components/uiParts/NumPad';
import BidSearchForm from '../../components/uiParts/bid/BidSearchForm';
import CustomConfirm from '../../components/confirm/CustomConfirm';
import BidMastaInputForm from '../../components/uiParts/bid/BidMastaInputForm';
import { dateToString, stringToDate } from '../../utils/Library';
import CustomSnackBar from '../../components/alert/CustomSnackBar';
import { fishStyleList, kgDivision, lineList, searchLineList, bidModeList } from '../../Store';
import CustomSelect from '../../components/select/CustomSelect';
import CustomCheckbox from '../../components/input/CustomCheckbox';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UpdateIcon from '@mui/icons-material/Update';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

const BidList = () => {
    
	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - 基本情報を設定
	//-----------------------------------------------
    const { authInfo }   = useAuth();
    const facilityCode   = authInfo.facilityCode;
    const facilityName   = authInfo.facilityName;
    const userId         = authInfo.userId;
    const luserName      = authInfo.userName;
    const authority      = authInfo.authority;
    const today          = authInfo.targetDate;

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ contentsHeight,           setContentsHeight           ] = useState(window.innerHeight -100);
    const [ dataGridHeight,           setDataGridHeight           ] = useState(window.innerHeight -290);
    const [ containerHeight,          setContainerHeight          ] = useState(window.innerHeight -100);
    const [ dataGridWidth,            setDataGridWidth            ] = useState(window.innerWidth -480);
    const [ condition ,               setCondition                ] = useState('');
	const [ searchStatus ,            setSearchStatus             ] = useState(1);
    const [ searchCount,              setSearchCount              ] = useState(0);
    const [ searchLineNo,             setSearchLineNo             ] = useState(99);
    const [ targetList,               setTargetList               ] = useState('');
    const [ entryDate,                setEntryDate                ] = useState(today);
    const [ bidList,                  setBidList                  ] = useState([]);
	const [ checkedBidList,           setCheckedBidList           ] = useState([]);
    const [ openDialogShip,           setOpenDialogShip           ] = useState(false);
    const [ openDialogShipDetail,     setOpenDialogShipDetail     ] = useState(false);
    const [ openDialogFishSpec,       setOpenDialogFishSpec       ] = useState(false);
    const [ openDialogFishSpecDetail, setOpenDialogFishSpecDetail ] = useState(false);
    const [ requireMessage,           setRequireMessage           ] = useState('');
    const [ shipList,                 setShipList                 ] = useState([]);
    const [ shipDetailList,           setShipDetailList           ] = useState([]);
    const [ fishSpecList,             setFishSpecList             ] = useState([]);
    const [ fishSpecDetailList,       setFishSpecDetailList       ] = useState([]);
    const [ standardList,             setStandardList             ] = useState([]);
    const [ memoList,                 setMemoList                 ] = useState([]);
    const [ danbeList,                setDanbeList                ] = useState([]);
    const [ openDialogStandard,       setOpenDialogStandard       ] = useState(false);
    const [ focusCell,                setFocusCell                ] = useState('');
    const [ fishMethodList,           setFishMethodList           ] = useState([]);
    const [ openDialogFishMethod,     setOpenDialogFishMethod     ] = useState(false);
    const [ openDialogFishStyle,      setOpenDialogFishStyle      ] = useState(false);
    const [ openDialogDanbeNo,        setOpenDialogDanbeNo        ] = useState(false);
    
    // 登録データ
    const [registerData, setRegisterData] = useState({
        uniqueId   : '',
        entryNo    : '',
        entryDate  : '',
        lineNo     : 1,
        senmei     : '',
        senmeiCode : '',
        senmei     : '',
        gyoshuCode : '',
        gyoshu     : '',
        methodCode : '',
        method     : '',
        kgKubun    : 1,
        nisugata   : 1,
        kikakuCode : '',
        kikaku     : '',
        kgSuryo    : '0.00',
        suryo      : 1,
        mikomiFlag : false,
        displayNo  : '',
        bidMode    : 0,
        bidStatus  : 0,
        danbeNo    : 0,
        danbeName  : '',
        memoCode   : '',
        memo       : '',
        unloadFlag : 0
    });
    // UI Message
    const [messageState, setMessageState] = useState({
        snackBarTrue  : false,
        snackBarFalse : false,
        snackBarPrint : false,
        require       : false,
    });
    
	//-----------------------------------------------
    // initialize - useRef
	//-----------------------------------------------
    const effectRan     = useRef(false);
    const senmeiRef     = useRef();
    const gyoshuRef     = useRef();
    const kikakuRef     = useRef();
    const kgSuryoRef    = useRef();
    const methodRef     = useRef();
    const suryoRef      = useRef();
    const danbeNoRef    = useRef();

	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - searchData / BidList
	//-----------------------------------------------
    const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost();
    const searchData = async () => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'keyword1'     : numericDate,
            'keyword2'     : condition,
            'keyword3'     : searchStatus,
            'keyword4'     : searchLineNo
        }
        await searchData_post(postData);
    };
	//-----------------------------------------------
    // API - getNextId / BidList
	//-----------------------------------------------
    const { response : getNextId_res, post : getNextId_post } = usePost();
    const getNextId = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'getNextId',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getNextId_post(postData);
    };
	//-----------------------------------------------
    // API - setData / BidList
	//-----------------------------------------------
    const { response : setData_res, post:setData_post } = usePost();
    const setData = async (targetData) => {
        const numericDate = dateToString(entryDate);
        const danbeData = danbeList.find(danbe => danbe.id == targetData.danbeNo);
        const danbeName = danbeData?.name ? danbeData.name : '';
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'setDataByBidder',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'activeFlag'   : targetData.activeFlag,
            'userId'       : userId,
            'uniqueId'     : targetData.uniqueId,
            'entryDate'    : numericDate,
            'lineNo'       : targetData.lineNo,
            'senmei'       : targetData.senmei,
            'senmeiCode'   : targetData.senmeiCode,
            'senmei'       : targetData.senmei,
            'gyoshuCode'   : targetData.gyoshuCode,
            'gyoshu'       : targetData.gyoshu,
            'methodCode'   : targetData.methodCode,
            'method'       : targetData.method,
            'kgKubun'      : targetData.kgKubun,
            'nisugata'     : targetData.nisugata,
            'kikakuCode'   : targetData.kikakuCode,
            'kikaku'       : targetData.kikaku,
            'kgSuryo'      : targetData.kgSuryo,
            'suryo'        : targetData.suryo,
            'mikomiFlag'   : targetData.mikomiFlag ? 1 : 0,
            'displayNo'    : targetData.displayNo,
            'bidStatus'    : targetData.bidStatus,
            'bidMode'      : targetData.bidMode,
            'danbeNo'      : targetData.danbeNo,
            'danbeName'    : danbeName,
            'memoCode'     : targetData.memoCode,
            'memo'         : targetData.memo,
            'unloadFlag'   : 0
        }
        await setData_post(postData);
    };
	//-----------------------------------------------
    // API - updateDisplayNo / BidList
	//-----------------------------------------------
    const { response : updateDisplayNo_res, post : updateDisplayNo_post } = usePost();
    const updateDisplayNo = async (uniqueIdList) => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'updateDisplayNo',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate,
            'uniqueIdList' : uniqueIdList,
        }
        await updateDisplayNo_post(postData);
    };
	//-----------------------------------------------
    // API - getDataByWeight / request_Transfer
	//-----------------------------------------------
    const { response : getDataByWeight_res, post : getDataByWeight_post } = usePost();
    const getDataByWeight = async () => {
        const postData = {
            'className'    : 'mch.models.request.Transfer',
            'methodName'   : 'getDataByWeight',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'lineNo'       : registerData.lineNo
        }
        await getDataByWeight_post(postData);
    };
	//-----------------------------------------------
    // API - setData / request_Print
	//-----------------------------------------------
    const { response : setDataByRequestPrint_res, post : setDataByRequestPrint_post } = usePost();
    const setDataByRequestPrint = async () => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'    : 'mch.models.request.Print',
            'methodName'   : 'setDataByPurchaseSlip',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'targetDate'   : numericDate,
            'printProc'    : 'purchaseSlip',
            'uniqueId'   : registerData.uniqueId,
        }
        await setDataByRequestPrint_post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.Ship
	//-----------------------------------------------
    const { response : getDataAll_ship_res, post : getDataAll_ship_post } = usePost();
    const getDataAll_ship = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_ship_post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.ship
	//-----------------------------------------------
    const { response : searchData_ship_res, post : searchData_ship_post } = usePost();
    const searchData_ship = async (initial) => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'searchDataByInitial',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'initial'      : initial
        }
        await searchData_ship_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.Ship
	//-----------------------------------------------
    const { response : getData_ship_res, post : getData_ship_post } = usePost();
    const getData_ship = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_ship_post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.FishSpec
	//-----------------------------------------------
    const { response : getDataAll_fishSpec_res, post : getDataAll_fishSpec_post } = usePost();
    const getDataAll_fishSpec = async () => {
        const postData = {
            'className'    : 'mch.models.masta.FishSpec',
            'methodName'   : 'searchDataByTimesNum',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_fishSpec_post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.fishSpec
	//-----------------------------------------------
    const { response : searchData_fishSpec_res, post : searchData_fishSpec_post } = usePost();
    const searchData_fishSpec = async (initial) => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalFishSpec',
            'methodName'   : 'searchDataByInitial',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'initial'      : initial
        }
        await searchData_fishSpec_post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.OriginalFishSpec
	//-----------------------------------------------
    const { response : getDataByStandardList_res, post : getDataByStandardList_post } = usePost();
    const getDataByStandardList = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalFishSpec',
            'methodName'   : 'getDataByStandardList',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getDataByStandardList_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.FishSpec
	//-----------------------------------------------
    const { response : getData_fishSpec_res, post : getData_fishSpec_post } = usePost();
    const getData_fishSpec = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.FishSpec',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_fishSpec_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.FishSpec
	//-----------------------------------------------
    const { response : updateTimesNum_res, post : updateTimesNum_post } = usePost();
    const updateTimesNum = async (gyoshuCode) => {
        const postData = {
            'className'    : 'mch.models.masta.FishSpec',
            'methodName'   : 'updateTimesNum',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : gyoshuCode,
            'activeFlag'   : 1
        }
        await updateTimesNum_post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.FishMethod
	//-----------------------------------------------
    const { response : getDataAll_fishMethod_res, post : getDataAll_fishMethod_post } = usePost();
    const getDataAll_fishMethod = async () => {
        const postData = {
            'className'    : 'mch.models.masta.FishMethod',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_fishMethod_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.FishMethod
	//-----------------------------------------------
    const { response : getData_fishMethod_res, post : getData_fishMethod_post } = usePost();
    const getData_fishMethod = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.FishMethod',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_fishMethod_post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.Standard
	//-----------------------------------------------
    const { response : getDataAll_standard_res, post : getDataAll_standard_post } = usePost();
    const getDataAll_standard = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_standard_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.standard
	//-----------------------------------------------
    const { response : getData_standard_res, post : getData_standard_post } = usePost();
    const getData_standard = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_standard_post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.Memo
	//-----------------------------------------------
    const { response : getDataAll_memo_res, post : getDataAll_memo_post } = usePost();
    const getDataAll_memo = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Memo',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_memo_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.Memo
	//-----------------------------------------------
    const { response : getData_memo_res, post : getData_memo_post } = usePost()
    const getData_memo = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Memo',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_memo_post(postData)
    }
	//-----------------------------------------------
    // API - searchData / masta.Danbe
	//-----------------------------------------------
    const { response : getDataAll_danbe_res, post : getDataAll_danbe_post } = usePost();
    const getDataAll_danbe = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Danbe',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_danbe_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.Danbe
	//-----------------------------------------------
    const { response : getData_danbe_res, post : getData_danbe_post } = usePost();
    // getData_fishMethod
    const getData_danbe = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Danbe',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_danbe_post(postData);
    };
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {
        // 初回マウント時のみ実行
        if (effectRan.current === false) {
            effectRan.current = true;

            setSearchCount(searchCount+1);
    
            //getDataAll_ship();
            //getDataAll_fishSpec();
            getDataAll_fishMethod();
            getDataAll_danbe();
            //getDataAll_standard();
            getDataAll_memo();
            
            senmeiRef.current.focus();
            setFocusCell('senmei');
            
            const handleResize = () => {
                setContentsHeight(window.innerHeight - 100);
                setDataGridHeight(window.innerHeight - 290);
                setContainerHeight(window.innerHeight - 100);
                setDataGridWidth(window.innerWidth - 480);
            }
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            }
        }
    },[]);
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData();
        setCheckedBidList([]);
    }, [searchCount]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / bidList)
	//-----------------------------------------------
    useEffect(() => {
        setBidList([]);
        if (searchData_res) {
            setBidList(searchData_res.Data);
        }
    }, [searchData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (getNextId_res) {
            const targetData = { ...registerData, uniqueId: getNextId_res.uniqueId, activeFlag: 1 };
            const requireStatus = checkedRequire(); // 必須項目をチェックする
            if (requireStatus) {
                setData(targetData);
            } else {
                setMessageInfo('require', true);
            }
        }
    }, [getNextId_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (updateDisplayNo_res) {
            setMessageInfo('snackBarTrue', true);
            setCheckedBidList([]);
            handleClick_new();
        }
    }, [updateDisplayNo_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            if (setData_res.statusCode == 9) {
                setRequireMessage('落札済みのため変更できません');
                setMessageInfo('require', true);
            } else if (setData_res.statusCode == 1) {
                setRequireMessage('入札が開始されているため変更できません');
                setMessageInfo('require', true);
            } else if (setData_res.statusCode == 8) {
                setRequireMessage('開票中のため変更できません');
                setMessageInfo('require', true);
            } else {
                //updateTimesNum(registerData.gyoshuCode); // 魚種の利用回数をカウントアップ
    
                setMessageInfo('confirm', false);
                setMessageInfo('snackBarTrue', true);
                    
                // 船名と魚種は記憶して初期化
                setRegisterData(prevSearchData => ({
                    ...prevSearchData,
                    entryNo     : '',
                    uniqueId    : '',
                    kikakuCode  : '',
                    kikaku      : '',
                    kgKubun     : 1,
                    kgSuryo     : '0.00',
                    suryo       : 1,
                    mikomiFlag  : false,
                    bidStatus   : 0,
                    bidMode     : 0,
                    danbeNo     : 0,
                    danbeName   : '',
                    unloadFlag  : 0
                }));
                
                setSearchCount(searchCount+1);
    
                // 規格にフォーカス
                kikakuRef.current.focus();
                setFocusCell('kikaku');
            }
        }
    }, [setData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataByWeight / request_transfer)
	//-----------------------------------------------
    useEffect(() => {
        if (getDataByWeight_res) {
            setRegisterData(prevSearchData => ({
                ...prevSearchData,
                kgSuryo    : getDataByWeight_res.weight,
            }));
        }
    }, [getDataByWeight_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataByWeight / request_transfer)
	//-----------------------------------------------
    useEffect(() => {
        if (setDataByRequestPrint_res) {
            setMessageInfo('snackBarPrint', true);
        }
    }, [setDataByRequestPrint_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        setShipList([]);
        if (getDataAll_ship_res) {
            setShipList(getDataAll_ship_res.Data);
        }
    }, [getDataAll_ship_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        setShipDetailList([]);
        if (searchData_ship_res) {
            setShipDetailList(searchData_ship_res.Data);
        }
    }, [searchData_ship_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_ship_res) {
            handleChange('senmeiGroupCode', getData_ship_res.groupCode);
            handleChange('senmeiGroup', getData_ship_res.group);
            handleChange('senmeiCode', getData_ship_res.code);
            handleChange('senmei', getData_ship_res.displayName);
        }
    }, [getData_ship_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        setFishSpecList([]);
        if (getDataAll_fishSpec_res) {
            setFishSpecList(getDataAll_fishSpec_res.Data);
        }
    }, [getDataAll_fishSpec_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        setFishSpecDetailList([]);
        if (searchData_fishSpec_res) {
            setFishSpecDetailList(searchData_fishSpec_res.Data);
        }
    }, [searchData_fishSpec_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_standard)
	//-----------------------------------------------
    useEffect(() => {
        setStandardList([]);
        if (getDataByStandardList_res) {
            setStandardList(getDataByStandardList_res.Data);
        }
    }, [getDataByStandardList_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishSpec_res) {
            handleChange('gyoshuCode', getData_fishSpec_res.code);
            handleChange('gyoshu', getData_fishSpec_res.displayName);
        }
    }, [getData_fishSpec_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_standard)
	//-----------------------------------------------
    useEffect(() => {
        setStandardList([]);
        if (getDataAll_standard_res) {
            setStandardList(getDataAll_standard_res.Data);
        }
    }, [getDataAll_standard_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_fishMethod)
	//-----------------------------------------------
    useEffect(() => {
        setFishMethodList([]);
        if (getDataAll_fishMethod_res) {
            setFishMethodList(getDataAll_fishMethod_res.Data);
        }
    }, [getDataAll_fishMethod_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishMethod)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishMethod_res) {
            handleChange('fishMethodCode', getData_fishMethod_res.code);
            handleChange('fishMethod', getData_fishMethod_res.displayName);
        }
    }, [getData_fishMethod_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_danbe)
	//-----------------------------------------------
    useEffect(() => {
        setDanbeList([]);
        if (getDataAll_danbe_res) {
            setDanbeList(getDataAll_danbe_res.Data);
        }
    }, [getDataAll_danbe_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_standard)
	//-----------------------------------------------
    useEffect(() => {
        setStandardList([]);
        if (getDataAll_standard_res) {
            setStandardList(getDataAll_standard_res.Data);
        }
    }, [getDataAll_standard_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_Standard)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_standard_res) {
            handleChange('kikakuCode', getData_standard_res.code);
            handleChange('kikaku', getData_standard_res.displayName);
        }
    }, [getData_standard_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_Standard)
	//-----------------------------------------------
    useEffect(() => {
        if (openDialogStandard == false && registerData.kikaku != '') {
            kgSuryoRef.current.focus();
            setFocusCell('kgSuryo');
        }
    }, [openDialogStandard]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_standard)
	//-----------------------------------------------
    useEffect(() => {
        setMemoList([]);
        if (getDataAll_memo_res) {
            getDataAll_memo_res.Data.unshift({id:'0',name:'未選択'});
            setMemoList(getDataAll_memo_res.Data);
        }
    }, [getDataAll_memo_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_memo)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_memo_res) {
            if (getData_memo_res.displayName) {
                handleChange('memoCode', getData_memo_res.code)
                handleChange('memo', getData_memo_res.displayName)
            } else {
                handleChange('memoCode', '')
                handleChange('memo', '')
            }
        }
    }, [getData_memo_res])
	//-----------------------------------------------
    // useEffect - dataGirdの選択
	//-----------------------------------------------
    useEffect(() => {
        if (targetList) {
            setRegisterData({ ...targetList,
                entryDate: stringToDate(targetList.entryDate),
                mikomiFlag: targetList.mikomiFlag ? true : false,
            });
        }
    }, [targetList]);
	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
        setEntryDate(value);
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - 見込みフラグの変更
	//-----------------------------------------------
    const handleChange_lineNo = (value) => {
        setSearchLineNo(value);
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - データの設定
	//-----------------------------------------------
    const handleChange = (name, value) => {
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            [name]: value,
        }));
    };
	//-----------------------------------------------
    // eventHandler - 検索ボタン
	//-----------------------------------------------
    const handleClick_search = () => {
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - 検索クリアボタン
	//-----------------------------------------------
    const handleClick_search_clear = () => {
        setEntryDate(today);
        setSearchLineNo(99);
        setCondition('');
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
	// eventHandler - 検索Statusの変更
	//-----------------------------------------------
    const handleChange_searchStatus = (checked) => {
        checked ? setSearchStatus(1) : setSearchStatus('');
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - 荷主にフォーカス
	//-----------------------------------------------
    const handleClick_senmei = () => {
        setFocusCell('senmei');
    };
	//-----------------------------------------------
    // eventHandler - 魚種にフォーカス
	//-----------------------------------------------
    const handleClick_gyoshu = () => {
        setFocusCell('gyoshu');
    };
	//-----------------------------------------------
    // eventHandler - 規格にフォーカス
	//-----------------------------------------------
    const handleClick_kikaku = () => {
        setFocusCell('kikaku');
    };
	//-----------------------------------------------
    // eventHandler - 容器にフォーカス
	//-----------------------------------------------
    const handleClick_fishMethod = () => {
        setFocusCell('method');
    };
	//-----------------------------------------------
    // eventHandler - 水槽番号にフォーカス
	//-----------------------------------------------
    const handleClick_danbeNo = () => {
        setFocusCell('danbeNo');
    };
	//-----------------------------------------------
    // eventHandler - 新規ボタン
	//-----------------------------------------------
    const handleClick_new = () => {
        setRegisterData({
            entryNo         : '',
            uniqueId        : '',
            entryDate       : '',
            lineNo          : 1,
            senmei          : '',
            senmeiCode      : '',
            senmei          : '',
            gyoshuCode      : '',
            gyoshu          : '',
            methodCode  : '',
            method      : '',
            kgKubun         : 1,
            nisugata        : 1,
            kikakuCode      : '',
            kikaku          : '',
            kgSuryo         : '0.00',
            suryo           : 1,
            mikomiFlag      : false,
            displayNo       : '',
            bidStatus       : 0,
            bidMode         : 0,
            danbeNo         : 0,
            danbeName       : '',
            unloadFlag      : 0
        })
        senmeiRef.current.focus();
        setFocusCell('senmei');
        setCheckedBidList([]);
        setTargetList('');
    };
	//-----------------------------------------------
    // eventHandler - マスタヘルプの戻るボタン
	//-----------------------------------------------
    const handleClick_help_prev = (item) => {
        if (item == 'senmei') {
            setOpenDialogShip(true);
            setOpenDialogShipDetail(false);
            setOpenDialogFishMethod(false);
            setOpenDialogFishSpec(false);
            setOpenDialogFishSpecDetail(false);
            setOpenDialogStandard(false);
            setOpenDialogFishStyle(false);
            setOpenDialogDanbeNo(false);
        } else if (item == 'method') {
            setOpenDialogShip(false);
            setOpenDialogShipDetail(false);
            setOpenDialogFishMethod(true);
            setOpenDialogFishSpec(false);
            setOpenDialogFishSpecDetail(false);
            setOpenDialogStandard(false);
            setOpenDialogFishStyle(false);
            setOpenDialogDanbeNo(false);
        } else if (item == 'fishSpec') {
            setOpenDialogShip(false);
            setOpenDialogShipDetail(false);
            setOpenDialogFishMethod(false);
            setOpenDialogFishSpec(true);
            setOpenDialogFishSpecDetail(false);
            setOpenDialogStandard(false);
            setOpenDialogFishStyle(false);
            setOpenDialogDanbeNo(false);
        } else if (item == 'standard') {
            setOpenDialogShip(false);
            setOpenDialogShipDetail(false);
            setOpenDialogFishMethod(false);
            setOpenDialogFishSpec(false);
            setOpenDialogFishSpecDetail(false);
            setOpenDialogStandard(true);
            setOpenDialogFishStyle(false);
            setOpenDialogDanbeNo(false);
        } else if (item == 'fishStyle') {
            setOpenDialogShip(false);
            setOpenDialogShipDetail(false);
            setOpenDialogFishMethod(false);
            setOpenDialogFishSpec(false);
            setOpenDialogFishSpecDetail(false);
            setOpenDialogStandard(false);
            setOpenDialogFishStyle(true);
            setOpenDialogDanbeNo(false);
        } else if (item == 'danbeNo') {
            setOpenDialogShip(false);
            setOpenDialogShipDetail(false);
            setOpenDialogFishMethod(false);
            setOpenDialogFishSpec(false);
            setOpenDialogFishSpecDetail(false);
            setOpenDialogStandard(false);
            setOpenDialogFishStyle(false);
            setOpenDialogDanbeNo(true);
        }
    };
	//-----------------------------------------------
    // eventHandler - 船名50音ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_shipDetail = () => {
        setOpenDialogShipDetail(true);
    };
	//-----------------------------------------------
    // eventHandler - 船名50音ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_shipDetail_close = () => {
        setOpenDialogShipDetail(false);
    };
	//-----------------------------------------------
    // eventHandler - 船名ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_ship = () => {
        setOpenDialogShip(true);
    };
	//-----------------------------------------------
    // eventHandler - 船名ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_ship_close = () => {
        setOpenDialogShip(false);
    };
	//-----------------------------------------------
    // eventHandler - 漁法ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_fishMethod = () => {
        setOpenDialogFishMethod(true);
    };
	//-----------------------------------------------
    // eventHandler - 漁法ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishMethod_close = () => {
        setOpenDialogFishMethod(false);
    };
	//-----------------------------------------------
    // eventHandler - 魚種ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpec = () => {
        setOpenDialogFishSpec(true);
    };
	//-----------------------------------------------
    // eventHandler - 魚種ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpec_close = () => {
        setOpenDialogFishSpec(false);
    };
	//-----------------------------------------------
    // eventHandler - 魚種50音ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpecDetail = () => {
        setOpenDialogFishSpecDetail(true);
    };
	//-----------------------------------------------
    // eventHandler - 魚種50音ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishSpecDetail_close = () => {
        setOpenDialogFishSpecDetail(false);
    };
	//-----------------------------------------------
    // eventHandler - 規格ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_standard = (gyoshuCode) => {
        // 規格を再描画する
        setStandardList([]);
        const code = gyoshuCode ? gyoshuCode : registerData.gyoshuCode;
        getDataByStandardList(code);
        setOpenDialogStandard(true);
    };
	//-----------------------------------------------
    // eventHandler - 規格ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_standard_close = () => {
        setOpenDialogStandard(false);
        kgSuryoRef.current.focus();
    };
	//-----------------------------------------------
    // eventHandler - 荷姿ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_fishStyle = () => {
        setOpenDialogFishStyle(true);
    };
	//-----------------------------------------------
    // eventHandler - 規格ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_fishStyle_close = () => {
        setOpenDialogFishStyle(false);
        kgSuryoRef.current.focus();
    };
    //-----------------------------------------------
    // eventHandler - 水槽番号ヘルプを表示
	//-----------------------------------------------
    const handleClick_dialog_danbeNo = () => {
        setOpenDialogDanbeNo(true);
    };
        //-----------------------------------------------
    // eventHandler - 水槽番号ヘルプを非表示
	//-----------------------------------------------
    const handleClick_dialog_danbeNo_close = () => {
        setOpenDialogDanbeNo(false);
        kgSuryoRef.current.focus();
    };
	//-----------------------------------------------
    // eventHandler - 登録ボタン
	//-----------------------------------------------
    const handleClick_Register = async (activeFlag) => {
        const targetData = { ...registerData, activeFlag };
        // 新規の場合はuniqueIdを発行して登録処理を実行
        if (!targetData.uniqueId) {
            await getNextId();
        
        // 更新の場合は既存のuniqueIdに対して登録処理を実行
        } else {
            const requireStatus = checkedRequire(); // 必須項目をチェックする
            if (requireStatus) {
                await setData(targetData);
            } else {
                setMessageInfo('require', true);
            }
        }
    };
	//-----------------------------------------------
    // eventHandler - メモの変更
	//-----------------------------------------------
    const handleChange_memo = (value) => {
        getData_memo(value)
    }
	//-----------------------------------------------
    // eventHandler - 見込みフラグの変更
	//-----------------------------------------------
    const handleChange_mikomiFlag = (checked) => {
        checked ? handleChange('mikomiFlag', 1) : handleChange('mikomiFlag', 0);
    };
	//-----------------------------------------------
    // eventHandler - 表示順の変更
	//-----------------------------------------------
    const handleClick_update_displayNo = () => {
        let uniqueIdStr = bidList.map(row => row.uniqueId).join('^');
        updateDisplayNo(uniqueIdStr);
    };
	//-----------------------------------------------
    // eventHandler - テンキーを操作
	//-----------------------------------------------
    const handleClick_numpad = (item) => {
        let prevVal;
        let targetVal;

        // ここで focusCell の値によって prevVal を設定する
        if (focusCell == 'senmei') {
            if (registerData.senmeiCode) {
                prevVal = '';
                handleChange('senmeiCode', '');
            } else {
                prevVal = registerData.senmei;
            }
        } else if (focusCell == 'gyoshu') {
            if (registerData.gyoshuCode) {
                prevVal = '';
                handleChange('gyoshuCode', '');
            } else {
                prevVal = registerData.gyoshu;
            }
        } else if (focusCell == 'kikaku') {
            if (registerData.kikakuCode) {
                prevVal = '';
                handleChange('kikakuCode', '');
            } else {
                prevVal = registerData.kikaku;
            }
        } else if (focusCell == 'kgSuryo') {
            prevVal = registerData.kgSuryo;
            if (prevVal == '0.00') {
                prevVal = '';
            }
        } else if (focusCell == 'method') {
            if (registerData.methodCode) {
                prevVal = '';
                handleChange('methodCode', '');
            } else {
                prevVal = registerData.method;
            }
        } else if (focusCell == 'suryo') {
            prevVal = registerData.suryo;
        } else {
        }
        if (item == 'C') {
            if (focusCell == 'senmei') { handleChange('senmeiCode', '');
            } else if (focusCell == 'gyoshu') { handleChange('gyoshuCode', '');
            } else if (focusCell == 'method') { handleChange('methodCode', '');
            } else if (focusCell == 'suryo') { handleChange('suryo', 1);
            } else {}
            targetVal = '';
        } else {
            targetVal = `${prevVal}${item}`;
        }

        // ここで focusCell の値によって異なる state 更新関数を呼び出す
        if (focusCell == 'senmei') {
            handleChange('senmei', targetVal);
        } else if (focusCell == 'gyoshu') {
            handleChange('gyoshu', targetVal);
        } else if (focusCell == 'kikaku') {
            handleChange('kikaku', targetVal);
        } else if (focusCell == 'kgSuryo') {
            handleChange('kgSuryo', targetVal);
        } else if (focusCell == 'method') {
            handleChange('method', targetVal);
        } else if (focusCell == 'suryo') {
            handleChange('suryo', targetVal);
        } else {}
    };
	//-----------------------------------------------
    // eventHandler - テンキーで「ENT」をクリック
	//-----------------------------------------------
    const handleClick_numpad_enter = () => {
        if (focusCell == 'senmei') {
            handleChange('senmeiCode', '');
            handleChange('senmei', '');
            getData_ship(registerData.senmei);
            methodRef.current.focus();
            setFocusCell('method');
        } else if (focusCell == 'method') {
            handleChange('methodCode', '');
            handleChange('method', '');
            getData_fishMethod(registerData.method);
            gyoshuRef.current.focus();
            setFocusCell('gyoshu');
        } else if (focusCell == 'gyoshu') {
            handleChange('gyoshuCode', '');
            handleChange('gyoshu', '');
            getData_fishSpec(registerData.gyoshu);
            kikakuRef.current.focus();
            setFocusCell('kikaku');
        } else if (focusCell == 'kikaku') {
            handleChange('kikakuCode', '');
            handleChange('kikaku', '');
            getData_standard(registerData.kikaku);
            kgSuryoRef.current.focus();
            setFocusCell('kgSuryo');
        } else if (focusCell == 'kgSuryo') {
            // 数字か小数点以外の文字を削除し、小数点1桁までに正規化
            const targetNumber = String(registerData.kgSuryo);
            let normalizedValue = targetNumber.replace(/[^0-9.]/g, ''); // 数字と小数点以外を削除

            // カンマを削除
            normalizedValue = normalizedValue.replace(/,/g, '');

            // ピリオドが最初にある場合、前に0を追加
            if (normalizedValue.indexOf('.') === 0) {
                normalizedValue = '0' + normalizedValue;
            }
            // ピリオドが最後にある場合、後ろに0を追加
            if (normalizedValue.lastIndexOf('.') === normalizedValue.length - 1) {
                normalizedValue = normalizedValue + '00';
            }
            // 2つ以上のピリオドがある場合、最初のピリオド以外を削除
            const parts = normalizedValue.split('.');
            // 整数部が空の場合、0を追加
            if (!parts[1]) {
                normalizedValue= normalizedValue + '.00';
            }
            if (parts.length > 2) {
                normalizedValue = parts[0] + '.' + parts[1];
            }
            // 整数部が0の場合、0を追加
            if (parts.length === 1 && parts[0] === '') {
                normalizedValue = '00';
            }
            // 小数部が2桁を超える場合、2桁までに切り捨てる
            if (parts.length === 2 && parts[1].length > 2) {
                parts[1] = parts[1].slice(0, 2);
                normalizedValue = parts.join('.');
            }
            handleChange('kgSuryo', normalizedValue);

            suryoRef.current.focus();
            setFocusCell('suryo');
        } else if (focusCell == 'method') {
            handleChange('methodCode', '');
            handleChange('method', '');
            getData_fishMethod(registerData.method);
            senmeiRef.current.focus();
            setFocusCell('senmei');
        } else if (focusCell == 'suryo') {
            senmeiRef.current.focus();
            setFocusCell('senmei');
        } else {}
    };
	//===============================================
	// dataGrid
	//===============================================
	//-----------------------------------------------
    // dataGrid - リストの見出し
	//-----------------------------------------------
    const columns = [
        { field: 'entryNo', headerName: 'No', width: 60, columnSeparatorWidth: 1, sortable:false, type:'number'},
        { field: 'lineNo', headerName: 'ライン', width: 60, columnSeparatorWidth: 1, sortable:false, type:'number'},
        { field: 'senmei', headerName: '荷主', width: 120, columnSeparatorWidth: 1, sortable:false, },
        { field: 'method', headerName: '漁法', width: 90, columnSeparatorWidth: 1, sortable:false, },
        { field: 'displayGyoshu', headerName: '品名', width: 150, columnSeparatorWidth: 1, sortable:false, },
        { field: 'kgSuryo', headerName: 'Kg数', width: 70, columnSeparatorWidth: 1, sortable:false, type:'number'},
        { field: 'suryo', headerName: '数量', width: 55, columnSeparatorWidth: 1, sortable:false, type:'number'},
        {
            field: 'kgKubun',
            headerName: '単位',
            width: 50, sortable:false,
            renderCell: (params) => (
              <div>
                {unitMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'displayBiko', headerName: '備考', width: 180, columnSeparatorWidth: 1, sortable:false, },
    ];
    const unitMapping = {
        1: 'Kg',
        0: '箱',
    };
    //-----------------------------------------------
    // dataGrid - 水揚一覧の行の選択
    //-----------------------------------------------
    const handleClick_dataGrid = (event) => {
        setTargetList(event.row);
    };
    //-----------------------------------------------
    // dataGrid - 船名マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_ship = (code, displayName) => {
        handleChange('senmeiCode', code);
        handleChange('senmei', displayName);
        handleClick_dialog_ship_close();
        handleClick_dialog_shipDetail_close();
        handleClick_dialog_fishMethod();
    };
    //-----------------------------------------------
    // dataGrid - 船名マスタ50音ヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_shipDetail = (initial) => {
        setShipDetailList([]);
        searchData_ship(initial);
        handleClick_dialog_ship_close();
        handleClick_dialog_shipDetail();
    };
    //-----------------------------------------------
    // dataGrid - 漁法マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishMethod = (code, displayName) => {
        handleChange('methodCode', code);
        handleChange('method', displayName);
        handleClick_dialog_fishMethod_close();
        handleClick_dialog_fishSpec();
    };
    //-----------------------------------------------
    // dataGrid - 魚種マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishSpec = (code, displayName) => {
        handleChange('gyoshuCode', code);
        handleChange('gyoshu', displayName);

        // 規格を再描画する
        setStandardList([]);
        getDataByStandardList(code);

        handleClick_dialog_fishSpec_close();
        handleClick_dialog_fishSpecDetail_close();
        handleClick_dialog_standard(code);
    };
    //-----------------------------------------------
    // dataGrid - 魚種マスタ50音ヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishSpecDetail = (initial) => {
        setFishSpecDetailList([]);
        searchData_fishSpec(initial);
        handleClick_dialog_fishSpec_close();
        handleClick_dialog_fishSpecDetail();
    };
    //-----------------------------------------------
    // dataGrid - 規格マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_standard = (code, displayName) => {
        handleChange('kikakuCode', code);
        handleChange('kikaku', displayName);
        handleClick_dialog_standard_close();
        handleClick_dialog_fishStyle();
    };
    //-----------------------------------------------
    // dataGrid - 荷姿マスタヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_fishStyle = (code, displayName) => {
        handleChange('nisugata', code);
        handleClick_dialog_fishStyle_close();
        handleClick_dialog_danbeNo();
    };
    //-----------------------------------------------
    // dataGrid - 水槽ヘルプの行の選択
    //-----------------------------------------------
    const handleClick_dataGrid_danbeNo = (code , displayName) => {
        handleChange('danbeNo', code);
        handleChange('danbeName', displayName);
        handleClick_dialog_danbeNo_close();
        setFocusCell('kgSuryo');
        kgSuryoRef.current.focus();
    };
    //-----------------------------------------------
    // dataGrid - 表示順の制御
    //-----------------------------------------------
    const areRowsConsecutive = (selectedIndexes) => {
        for (let i = 1; i < selectedIndexes.length; i++) {
            if (selectedIndexes[i] - selectedIndexes[i - 1] !== 1) {
                return false;
            }
        }
        return true;
    };
    //-----------------------------------------------
    // dataGrid - 表示順の変更
    //-----------------------------------------------
    const moveRows = (direction) => {
        let newRows = [...bidList];
        let selectedIndexes = checkedBidList.map(selectedId => 
            newRows.findIndex(row => row.id === selectedId)).sort((a, b) => a - b);        
        if (!areRowsConsecutive(selectedIndexes)) {
            setRequireMessage('行の移動には連続した行をチェックしてください');
            setMessageInfo('require', true);
            return;
        }
        if (areRowsConsecutive(selectedIndexes)) {
            if (direction === 'up' && selectedIndexes[0] > 0) {
                for (let i = 0; i < selectedIndexes.length; i++) {
                    const index = selectedIndexes[i];
                    [newRows[index], newRows[index - 1]] = [newRows[index - 1], newRows[index]];
                }
            } else if (direction === 'down' && selectedIndexes[selectedIndexes.length - 1] < newRows.length - 1) {
                for (let i = selectedIndexes.length - 1; i >= 0; i--) {
                    const index = selectedIndexes[i];
                    [newRows[index], newRows[index + 1]] = [newRows[index + 1], newRows[index]];
                }
            }
        }
        setBidList(newRows);
    };
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const errorFields = [];
        
        //if (!uniqueId) errorFields.push('「伝票番号」')
        if (!registerData.senmeiCode) errorFields.push('「荷主」');
        if (!registerData.methodCode) errorFields.push('「漁法」');
        if (!registerData.gyoshuCode) errorFields.push('「品名」');
        if (registerData.kikakuCode === '') errorFields.push('「規格」');
        if (!registerData.kgSuryo) errorFields.push('「K数」');
    
        if (errorFields.length) {
            const text = errorFields.join('、') + 'が入力されていません';
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        return true;  // エラーがない場合は true を返します
    };
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }));
    };
    const handleClick_weight = () => {
        getDataByWeight();
    };
    const handleClick_print = () => {
        if (!registerData.uniqueId) {
            setRequireMessage('印刷対象の行を選択してください');
            setMessageInfo('require', true);
        } else {
        setDataByRequestPrint();
        }
    };
    //===============================================
    // Css
    //===============================================
    const button_new = {
        fontSize: '19px', height:'60px', width:'95px', color:'#fff', backgroundColor:'#305496'
    };
    const button_calc = {
        fontSize: '18px', height:'60px', width:'95px', color:'#fff', backgroundColor:'#ff7f50' 
    };
    const button_print = {
        fontSize: '18px', height:'60px', width:'95px', color:'#fff'
    };
    const button_delete = { 
        fontSize: '18px', height:'70px', width:'95px', color:'#fff', backgroundColor:'#ff0000'
    };
    const dialog_button_close = { 
        fontSize: '16px', height:'40px', width:'690px', color:'#fff', backgroundColor:'#808080'
    };
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/home" setEntryDate={handleChange_entryDate} />
            <div className='bidList bodyContens'>
                <TitleBar title="荷受け" />
                <div style={{ display: 'flex', height: containerHeight }} className='mainContents'>
                    <div style={{ flex: 1, padding: '0px' }}>
                        <Frame classname="frame" title="荷受け検索">
                        <div style={{display:'flex'}}>
                            <div style={{marginRight:'10px'}}>
                                <CustomSelect
                                    id         = "bidList_search_lineNo"
                                    label      = "ラインNo"
                                    width      = "100px"
                                    dataList   = {searchLineList} 
                                    selectedId = {searchLineNo}
                                    onChange   = {(e) => handleChange_lineNo(e.target.value)}
                                />
                            </div>
                            <div>
                                <BidSearchForm
                                    targetDateId       = "bidList_targetDate"
                                    targetDateValue    = { entryDate }
                                    targetDateOnChange = { (e) => setEntryDate(e.target.value) }
                                    keywordId          = "bidList_condition"
                                    keywordValue       = { condition }
                                    keywordOnChange    = { (e) => setCondition(e.target.value) }
                                    handleSearch       = { () => handleClick_search() }
                                    handleSearchClear  = { () => handleClick_search_clear() }
                                />
                            </div>
                            <div style={{marginLeft:'10px'}}>
                                <CustomCheckbox
                                    defaultChecked = { searchStatus }
                                    onChange       = { (e) => handleChange_searchStatus(e.target.checked) }
                                    label          = "入札未実施のみ"
                                />
                                </div>
                            </div>
                        </Frame>
                        <Frame classname="frame" title="荷受け一覧">
                            <div style={{display:'flex'}}>
                                <div style={{marginBottom:'0px', marginLeft:'0px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<UpdateIcon />}
                                        onClick   = {() => handleClick_search() }
                                    >
                                    リスト更新
                                    </Button>
                                </div>
                                <div style={{marginLeft:'255px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "primary"
                                        style     = {{color:'#fff',paddingLeft:'30px'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<ArrowCircleUpIcon />}
                                        onClick={ () => moveRows('up')}
                                    >
                                    </Button>
                                </div>
                                <div style={{marginLeft:'10px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "primary"
                                        style     = {{color:'#fff',paddingLeft:'30px'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<ArrowCircleDownIcon />}
                                        onClick={ () => moveRows('down')}
                                    >
                                    </Button>
                                </div>
                                <div style={{marginBottom:'0px', marginLeft:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<SyncAltIcon />}
                                        onClick   = {() => handleClick_update_displayNo() }
                                    >
                                    表示順更新
                                    </Button>
                                </div>
                                {/*
                                <div style={{marginLeft:'20px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<CheckBoxIcon />}
                                        onClick={ () => handleClick_groupNo_register()}
                                    >{"グループ登録"}
                                    </Button>
                                </div>
                                <div style={{marginLeft:'10px', marginBottom:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        style     = {{color:'#fff'}}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<CheckBoxOutlineBlankIcon />}
                                        onClick={ () => handleClick_groupNo_delete()}
                                    >{"グループ解除"}
                                    </Button>
                                </div>
                                */}
                            </div>
                            <div style={{ flexGrow: 1, width: dataGridWidth}}>
                                <CustomDataGrid
                                    getRowClassName={(params) => {
                                        let className = ''
                                        if (params.indexRelativeToCurrentPage % 2 === 0) {
                                            className += 'even '
                                        } else {
                                            className += 'odd '
                                        }
                                        if (params.row.unloadFlag) {
                                            className += 'cell_inUnload'
                                        }
                                        return className.trim() // クラス名の文字列の前後の余分な空白を削除
                                    }}
                                    editMode                = "row"
                                    rows                    = { bidList }
                                    columns                 = { columns }
                                    sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                                    density                 = "compact"
                                    localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                    showColumnRightBorder
                                    showCellRightBorder
                                    disableRowSelectionOnClick = {false}
                                    disableColumnMenu          = {true}
                                    loading                 = { searchData_Loading }
                                    onCellClick             = {(event) => handleClick_dataGrid(event)}
                                    onRowSelectionModelChange  = {(newSelectionModel) => { setCheckedBidList(newSelectionModel) }}
                                    rowSelectionModel          = {checkedBidList}
                                />
                            </div>
                        </Frame>
                    </div>
                    <div style={{ width: '410px', padding: '0px'}}>
                            <div style={{backgroundColor:'#efefef', padding:'10px', height : contentsHeight}}>
                                <div style={ {marginRight : '10px', display : 'flex', marginTop : '0px'} }>
                                    <div style={{marginLeft:'0px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "bidList_kikaku"
                                            label    = "No"
                                            value    = { registerData.entryNo }
                                            width    = "70px"
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomSelect
                                            id         = "bidList_lineNo"
                                            label      = "ライン"
                                            width      = "90px"
                                            dataList   = {lineList} 
                                            selectedId = {registerData.lineNo}
                                            onChange   = {(e) => handleChange('lineNo', e.target.value)}
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomSelect
                                            id         = "bidList_kgKubun"
                                            label      = "単位"
                                            width      = "110px"
                                            dataList   = {kgDivision} 
                                            selectedId = {registerData.kgKubun}
                                            onChange = {(e) => handleChange('kgKubun', e.target.value)}
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomSelect
                                            id         = "bidList_bidMode"
                                            label      = "販売形態"
                                            width      = "110px"
                                            dataList   = {bidModeList} 
                                            selectedId = {registerData.bidMode}
                                            onChange = {(e) => handleChange('bidMode', e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={{ marginRight : '10px', marginTop: '7px', display : 'flex', }}>
                                    <BidMastaInputForm
                                        mastaName        = '荷主'
                                        inputRef         = { senmeiRef }
                                        inputId          = 'bidList_senmei'
                                        handleClick      = {() => handleClick_dialog_ship()}
                                        nameValue        = { registerData.senmei }
                                        handleChangeName = {(e) => handleChange('senmei', e.target.value)}
                                        handleClickName  = {() => handleClick_senmei()}
                                    />
                                </div>
                                <div style={{ marginRight : '10px', marginTop: '7px', display : 'flex', }}>
                                    <BidMastaInputForm
                                        mastaName        = '漁法'
                                        inputRef         = { methodRef }
                                        inputId          = 'bidList_method'
                                        handleClick      = {() => handleClick_dialog_fishMethod()}
                                        nameValue        = { registerData.method }
                                        handleChangeName = {(e) => handleChange('method', e.target.value)}
                                        handleClickName  = {() => handleClick_fishMethod()}
                                    />
                                </div>
                                <div style={{marginRight:'10px', display:'flex', marginTop:'10px'}}>
                                    <div style={{marginLeft:'0px'}}>
                                        <Button color="primary" size="large" variant="contained"
                                            sx={{ fontSize: '13px', height:'38px', width:'70px' }}
                                            onClick      = {() => handleClick_dialog_fishSpec()}
                                            >品名
                                        </Button>
                                    </div>
                                    <div style={{marginLeft:'4px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "bidList_gyoshu"
                                            inputRef = { gyoshuRef }
                                            label    = "品名"
                                            value    = { registerData.gyoshu }
                                            onClick  = {() => handleClick_gyoshu()}
                                            onChange = {(e) => handleChange('gyoshu', e.target.value)}
                                            width    = "220px"
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <CustomSelect
                                            id         = "userList_authority"
                                            label      = "荷姿"
                                            width      = "95px"
                                            dataList   = {fishStyleList} 
                                            selectedId = {registerData.nisugata}
                                            onChange = {(e) => handleChange('nisugata', e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={{ marginRight : '10px', marginTop: '7px', display : 'flex', }}>
                                    <div style={{marginLeft:'0px'}}>
                                        <Button color="primary" size="large" variant="contained"
                                            sx={{ fontSize: '13px', height:'38px', width:'70px' }}
                                            onClick      = {() => handleClick_dialog_standard('')}
                                            >規格
                                        </Button>
                                    </div>
                                    <div style={{marginLeft:'4px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "bidList_kikaku"
                                            inputRef = { kikakuRef }
                                            label    = "規格"
                                            value    = { registerData.kikaku }
                                            onClick  = {() => handleClick_kikaku()}
                                            onChange = {(e) => handleChange('kikaku', e.target.value)}
                                            width    = "220px"
                                        />
                                    </div>
                                    <div style={{marginLeft:'10px'}}>
                                        <CustomCheckbox
                                            defaultChecked = { registerData.mikomiFlag }
                                            width      = "100px"
                                            onChange       = { (e) => handleChange_mikomiFlag(e.target.checked) }
                                            label          = "見込み"
                                        />
                                    </div>
                                </div>
                                <div style={ {marginRight : '10px', display : 'flex', marginTop : '7px'} }>
                                    {/* <div style={{marginLeft:'0px'}}> 
                                        <CustomSelect
                                            id         = "userList_authority"
                                            label      = "メモ"
                                            width      = "195px"
                                            dataList   = {memoList} 
                                            selectedId = {registerData.memoCode}
                                            onChange = {(e) => handleChange_memo(e.target.value)}
                                        /> */}
                                    <div style={{marginLeft:'0px'}}>
                                        <Button color="primary" size="large" variant="contained"
                                            sx={{ fontSize: '13px', height:'38px', width:'70px' }}
                                            onClick      = {() => handleClick_dialog_danbeNo()}
                                            >水槽
                                        </Button>
                                    </div>
                                    <div style={{marginLeft:'4px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "bidList_danbeNo"
                                            inputRef = { danbeNoRef }
                                            label    = "水槽番号"
                                            value    = { registerData.danbeName }
                                            onClick  = {() => handleClick_danbeNo()} 
                                            onChange = {(e) => handleChange('danbeNo', e.target.value)} 
                                            width    = "120px"
                                        />
                                    </div>
                                    <div style={{marginLeft:'4px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id       = "bidList_kgSuryo"
                                            inputRef = { kgSuryoRef }
                                            label    = "K数"
                                            value    = { registerData.kgSuryo }
                                            onClick  = {() => setFocusCell('kgSuryo')}
                                            onChange = {(e) => handleChange('kgSuryo', e.target.value)}
                                            width    = "85px"
                                        />
                                    </div>
                                    <div style={{marginLeft:'5px'}}>
                                        <ReaOnlyOutlinedInput
                                            type     = "text"
                                            id         = "bidList_suryo"
                                            inputRef = { suryoRef }
                                            label      = "数量"
                                            width      = "85px"
                                            value    = { registerData.suryo }
                                            onClick  = {() => setFocusCell('suryo')}
                                            onChange = {(e) => handleChange('suryo', e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={{display:'flex'}}>
                                    <div>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "attention"
                                                size    = "large"
                                                variant = "contained"
                                                sx      = { button_calc }
                                                onClick = { () => handleClick_weight() }
                                            >{'重量 取得'}
                                            </Button>
                                        </div>
                                        <div style={{marginTop:'9px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                sx      = { button_print }
                                                onClick = { () => handleClick_print() }
                                            >{'仕入 伝票'}
                                            </Button>
                                        </div>
                                        <div style={{marginTop:'77px'}}>
                                            <Button
                                                color   = "primary"
                                                size    = "large"
                                                variant = "contained"
                                                sx      = { button_new }
                                                onClick = { () => handleClick_new() }
                                            >{'新規'}
                                            </Button>
                                        </div>
                                    </div>
                                    <div style={{ width:'290px', paddingTop:'5px', marginLeft:'7px'}}>
                                        <NumPad onKeyPress = { (e) => handleClick_numpad(e) } array={['7', '8', '9', '4', '5', '6', '1', '2', '3', '0', '.', 'C']} />
                                    </div>
                                </div>
                                <div style={{display:'flex'}}>
                                    <div style={{display:'flex'}}>
                                        <div style={{marginTop:'5px'}}>
                                            <Button
                                                color   = "attention"
                                                size    = "large"
                                                variant = "contained"
                                                sx      = { button_delete }
                                                onClick = { () => setMessageInfo('confirm', true) }
                                            >{'削除'}
                                            </Button>
                                        </div>
                                        <div style={{marginLeft:'7px', marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '22px', height:'70px', width:'93px', color:'#fff', backgroundColor:'#808080' }}
                                                onClick = {() => handleClick_numpad_enter()}
                                                >
                                                {'ENT'}
                                            </Button>
                                        </div>
                                        <div style={{marginLeft:'5px', marginTop:'5px'}}>
                                            <Button
                                                color   = "secondary"
                                                size    = "large"
                                                variant = "contained"
                                                style   = {{ fontSize: '22px', height:'70px', width:'195px', color:'#fff', backgroundColor:'#4A9DBC' }}
                                                onClick = {() => handleClick_Register('1')}
                                                >
                                                {'登録'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div className='dialog_shipList'>
                    <Dialog open={ openDialogShip } onClose={ handleClick_dialog_ship_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="荷主(50音順)を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                        <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('あ')}>あ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('い')}>い</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('う')}>う</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('え')}>え</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('お')}>お</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('か')}>か</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('き')}>き</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('く')}>く</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('け')}>け</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('こ')}>こ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('さ')}>さ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('し')}>し</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('す')}>す</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('せ')}>せ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('そ')}>そ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('た')}>た</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('ち')}>ち</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('つ')}>つ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('て')}>て</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('と')}>と</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('な')}>な</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('に')}>に</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('ぬ')}>ぬ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('ね')}>ね</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('の')}>の</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('は')}>は</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('ひ')}>ひ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('ふ')}>ふ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('へ')}>へ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('ほ')}>ほ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('ま')}>ま</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('み')}>み</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('む')}>む</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('め')}>め</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('も')}>も</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('や')}>や</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('ゆ')}>ゆ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px', marginRight:'300px'}} onClick = {() => handleClick_dataGrid_shipDetail('よ')}>よ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('ら')}>ら</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('り')}>り</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('る')}>る</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('れ')}>れ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('ろ')}>ろ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('わ')}>わ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('を')}>を</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_shipDetail('ん')}>ん</Button>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('senmeiGroup')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_ship_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_shipList'>
                    <Dialog open={ openDialogShipDetail } onClose={ handleClick_dialog_shipDetail_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="荷主を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {shipDetailList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', height:'60px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_ship(item.code, item.name)}
                                >{item.name}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('senmei')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_shipDetail_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishSpecList'>
                    <Dialog open={ openDialogFishSpec } onClose={ handleClick_dialog_fishSpec_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="魚種（50音）を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('あ')}>あ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('い')}>い</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('う')}>う</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('え')}>え</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('お')}>お</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('か')}>か</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('き')}>き</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('く')}>く</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('け')}>け</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('こ')}>こ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('さ')}>さ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('し')}>し</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('す')}>す</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('せ')}>せ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('そ')}>そ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('た')}>た</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('ち')}>ち</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('つ')}>つ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('て')}>て</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('と')}>と</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('な')}>な</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('に')}>に</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('ぬ')}>ぬ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('ね')}>ね</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('の')}>の</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('は')}>は</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('ひ')}>ひ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('ふ')}>ふ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('へ')}>へ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('ほ')}>ほ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('ま')}>ま</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('み')}>み</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('む')}>む</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('め')}>め</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('も')}>も</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('や')}>や</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('ゆ')}>ゆ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px', marginRight:'300px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('よ')}>よ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('ら')}>ら</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('り')}>り</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('る')}>る</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('れ')}>れ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('ろ')}>ろ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('わ')}>わ</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('を')}>を</Button>
                            <Button color = "fifthly" size ="large" variant ="contained" style = {{color:'#fff', width:'170px', margin:'10px', marginBottom:'0px'}} onClick = {() => handleClick_dataGrid_fishSpecDetail('ん')}>ん</Button>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('method')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishSpec_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishSpecDetailList'>
                    <Dialog open={ openDialogFishSpecDetail } onClose={ handleClick_dialog_fishSpecDetail_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="魚種を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {fishSpecDetailList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_fishSpec(item.code, item.name)}
                                >{item.name}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('fishSpec')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishSpecDetail_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishStyleList'>
                    <Dialog open={ openDialogFishStyle } onClose={ handleClick_dialog_fishStyle_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="荷姿を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {fishStyleList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_fishStyle(item.id, item.name)}
                                >{item.name}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('standard')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishStyle_close()}
                                startIcon = {<CloseIcon />}setKgKubun
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_fishMethodList'>
                    <Dialog open={ openDialogFishMethod } onClose={ handleClick_dialog_fishMethod_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="漁法を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {fishMethodList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px', textTransform: 'none'}}
                                    onClick = {() => handleClick_dataGrid_fishMethod(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('senmei')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_fishMethod_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_kikakuList'>
                    <Dialog open={ openDialogStandard } onClose={ handleClick_dialog_standard_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="規格マスタ検索" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {standardList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px'}}
                                    onClick = {() => handleClick_dataGrid_standard(item.code, item.displayName)}
                                >{item.displayName}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('fishSpec')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_standard_close()}
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <div className='dialog_danbeList'>
                    <Dialog open={ openDialogDanbeNo } onClose={ handleClick_dialog_danbeNo_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="水槽番号を選択" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'1020px', height:'650px'}}>
                            {danbeList.map(item => (
                                <Button
                                    color   = "secondary"
                                    size    ="large"
                                    variant ="contained"
                                    style   = {{color:'#fff', width:'170px', margin:'10px', textTransform: 'none'}}
                                    onClick = {() => handleClick_dataGrid_danbeNo(item.id, item.name)}
                                >{item.name}
                                </Button>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color   = "primary"
                                size    ="large"
                                variant ="contained"
                                style = {{color:'#fff', width:'200px', marginRight:'5%', marginBottom:'2%', marginLeft: '5%'}}
                                onClick = {() => handleClick_help_prev('standard')}
                                startIcon = {<ArrowBackIcon />}
                            >戻る
                            </Button>
                            <Button
                                color     = "tertiary"
                                size      = "large"
                                variant   = "contained"
                                sx        = { dialog_button_close }
                                style = {{width:'500px', marginRight:'10%', marginBottom:'2%'}}
                                onClick   = {() => handleClick_dialog_danbeNo_close()} 
                                startIcon = {<CloseIcon />}
                            >{'閉じる'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarFalse}
                    onClose         = {() => setMessageInfo('snackBarFalse', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarPrint}
                    onClose         = {() => setMessageInfo('snackBarPrint', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "印刷指示を送信しました"
                />
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm}
                    onClose   = {() => setMessageInfo('confirm', false)}
                    onClickNG = {() => setMessageInfo('confirm', false)}
                    onClickOK = {() => handleClick_Register(0)}
                    message   = "指定データの削除を行います。よろしいですか？"
                />
            </div>
        </>
    )
}
export default BidList;